"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.link");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ButtonLink = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonLink, _React$Component);

  var _super = _createSuper(ButtonLink);

  function ButtonLink() {
    var _this;

    _classCallCheck(this, ButtonLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      disabled: false
    };

    _this.disableOnClick = function () {
      return _this.setState({
        disabled: true
      });
    };

    _this.enableAfterTime = function (t) {
      return window.setTimeout(function () {
        return _this.setState({
          disabled: false
        });
      }, t);
    };

    return _this;
  }

  _createClass(ButtonLink, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          disableWith = _this$props.disableWith,
          disableTime = _this$props.disableTime,
          children = _this$props.children,
          _onClick = _this$props.onClick,
          others = _objectWithoutProperties(_this$props, ["disableWith", "disableTime", "children", "onClick"]);

      var disabled = this.state.disabled;
      return /*#__PURE__*/_react.default.createElement(SC.Button, _extends({
        onClick: function onClick(e) {
          _this2.disableOnClick();

          disableTime > 0 && _this2.enableAfterTime(disableTime);
          _onClick && _onClick(e);
        },
        disabled: disabled
      }, others), disabled ? disableWith || children : children);
    }
  }]);

  return ButtonLink;
}(_react.default.Component);

var SC = {};
SC.Button = _styledComponents.default.button.withConfig({
  displayName: "Link__Button",
  componentId: "g67q0a-0"
})(["", ";font-weight:normal;border-radius:0;text-transform:none;font-size:", ";padding:0 15px;&,&:active,&.active,&[disabled],fieldset[disabled] &{background-color:transparent;box-shadow:none;}&,&:hover,&:focus,&:active{border-color:transparent;background-color:transparent;}&:hover,&:focus{", ";background-color:transparent;}&[disabled],fieldset[disabled] &{&:hover,&:focus{cursor:not-allowed;color:", ";text-decoration:none;background-color:transparent;}}"], function (props) {
  return props.theme.textStyles.link;
}, function (props) {
  return props.theme.fontSizes[1];
}, function (props) {
  return props.theme.textStyles.link['&:hover'];
}, function (props) {
  return props.theme.textStyles.link.color;
});
ButtonLink.defaultProps = {
  disableTime: 0
};
ButtonLink.propTypes = {
  disableWith: _propTypes.default.string,
  // milliseconds after click that the link should be re-enabled. Default
  // 0 which means no re-enablement.
  disableTime: _propTypes.default.number,
  children: _propTypes.default.node.isRequired
};
var _default = ButtonLink;
exports.default = _default;